import React from 'react'
import { styled } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const CloseButtonWrapper = styled('button')({
  color: 'white',
  position: 'fixed',
  top: 16,
  right: 16,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
})
interface CloseButtonProps {
  onClose: () => void
}

export function CloseButton (props: CloseButtonProps): JSX.Element {
  return (
    <CloseButtonWrapper onClick={props.onClose}>
      <CloseIcon />
    </CloseButtonWrapper>
  )
}
